import React, {useState, useEffect} from 'react';
import {convertCurrencyFormatPositiveNegative} from "@moeindal/base-raiko-panel-components";
import "./CountUp.scss"

const CountUp = ({end, duration}) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const increment = Math.ceil(end / (duration / 50)); // Update every 50ms
        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(timer);
                setCount(end);
            } else {
                setCount(start);
            }
        }, 50);

        return () => clearInterval(timer);
    }, [end, duration]);

    return <span className={"countStyle"}>{convertCurrencyFormatPositiveNegative(count)}</span>;
};

export default CountUp;